import { useEffect } from 'react';
export const useKeybind = () => {
    const keyupHandler = (e) => {
        if (e.target instanceof HTMLInputElement ||
            e.target instanceof HTMLTextAreaElement)
            return;
        if (e.code === 'KeyD') {
            const tree_item = document
                .querySelector('.tree')
                ?.querySelector('.tab-click');
            if (!tree_item)
                return;
            tree_item.focus();
        }
        const target = e?.target;
        // Если нажатие было не на дереве
        if (!target?.classList.contains('tab-click'))
            return;
        switch (e.code) {
            case 'Enter':
                target?.click();
                break;
            case 'ArrowDown': {
                target
                    .closest('[data-index]')
                    ?.nextElementSibling?.querySelector('.tab-click')
                    ?.focus();
                break;
            }
            case 'ArrowUp': {
                target
                    .closest('[data-index]')
                    ?.previousElementSibling?.querySelector('.tab-click')
                    ?.focus();
                break;
            }
            default:
        }
    };
    useEffect(() => {
        document.addEventListener('keydown', keyupHandler);
        return () => document.removeEventListener('keydown', keyupHandler);
    });
};
